import AppAuthorizer from './AppAuthorizer'

export default AppAuthorizer
